import store from '../store/Store';

/**
 * Util to get whether the user is a first time user of personal bookings.
 */
export default function getFirstTimeUser(): boolean {
    return store.firstTimeUser; //We will switch to getUserOnboardingState in Future
}
